import { render, staticRenderFns } from "./ModelDocYC.vue?vue&type=template&id=315214c9"
import script from "./ModelDocYC.vue?vue&type=script&lang=js"
export * from "./ModelDocYC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports